"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ModelField = exports.ArrayField = exports.IntegerField = exports.IdField = exports.CharField = exports.BooleanField = exports.Field = void 0;

var _tnUtils = require("@thinknimble/tn-utils");

var _validation = require("../validation");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Field = /*#__PURE__*/function () {
  function Field() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$defaultVal = _ref.defaultVal,
        defaultVal = _ref$defaultVal === void 0 ? null : _ref$defaultVal,
        _ref$readOnly = _ref.readOnly,
        readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly;

    _classCallCheck(this, Field);

    Object.assign(this, {
      defaultVal: defaultVal,
      readOnly: readOnly
    });
  }
  /**
   * Read a field value.
   *
   * Can be used to raise validation errors and sanitize values
   * for the field type.
   */


  _createClass(Field, [{
    key: "clean",
    value: function clean(value) {
      return (0, _validation.notNullOrUndefined)(value) ? value : this.getDefaultVal();
    }
  }, {
    key: "getDefaultVal",
    value: function getDefaultVal() {
      return (0, _validation.isFunction)(this.defaultVal) ? this.defaultVal() : this.defaultVal;
    }
  }]);

  return Field;
}();

exports.Field = Field;

var BooleanField = /*#__PURE__*/function (_Field) {
  _inherits(BooleanField, _Field);

  var _super = _createSuper(BooleanField);

  function BooleanField(opts) {
    _classCallCheck(this, BooleanField);

    return _super.call(this, _objectSpread({}, opts, {
      defaultVal: false
    }));
  }

  _createClass(BooleanField, [{
    key: "clean",
    value: function clean(value) {
      return (0, _validation.notNullOrUndefined)(value) ? Boolean(value) : this.getDefaultVal();
    }
  }]);

  return BooleanField;
}(Field);

exports.BooleanField = BooleanField;

var CharField = /*#__PURE__*/function (_Field2) {
  _inherits(CharField, _Field2);

  var _super2 = _createSuper(CharField);

  function CharField(opts) {
    _classCallCheck(this, CharField);

    return _super2.call(this, _objectSpread({}, opts, {
      defaultVal: ''
    }));
  }

  _createClass(CharField, [{
    key: "clean",
    value: function clean(value) {
      return (0, _validation.notNullOrUndefined)(value) ? String(value) : this.getDefaultVal();
    }
  }]);

  return CharField;
}(Field);

exports.CharField = CharField;

var IdField = /*#__PURE__*/function (_Field3) {
  _inherits(IdField, _Field3);

  var _super3 = _createSuper(IdField);

  function IdField(opts) {
    _classCallCheck(this, IdField);

    return _super3.call(this, _objectSpread({}, opts, {
      defaultVal: _tnUtils.random.randomString
    }));
  }

  return IdField;
}(Field);

exports.IdField = IdField;

var IntegerField = /*#__PURE__*/function (_Field4) {
  _inherits(IntegerField, _Field4);

  var _super4 = _createSuper(IntegerField);

  function IntegerField() {
    _classCallCheck(this, IntegerField);

    return _super4.apply(this, arguments);
  }

  _createClass(IntegerField, [{
    key: "clean",
    value: function clean(value) {
      return (0, _validation.notNullOrUndefined)(value) ? Number(value) : this.getDefaultVal();
    }
  }]);

  return IntegerField;
}(Field);

exports.IntegerField = IntegerField;

var ArrayField = /*#__PURE__*/function (_Field5) {
  _inherits(ArrayField, _Field5);

  var _super5 = _createSuper(ArrayField);

  function ArrayField() {
    var _this;

    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$defaultVal = _ref2.defaultVal,
        defaultVal = _ref2$defaultVal === void 0 ? null : _ref2$defaultVal,
        _ref2$readOnly = _ref2.readOnly,
        readOnly = _ref2$readOnly === void 0 ? false : _ref2$readOnly,
        _ref2$type = _ref2.type,
        type = _ref2$type === void 0 ? null : _ref2$type;

    _classCallCheck(this, ArrayField);

    if (!type) {
      throw Error('`type` is a required parameter for ArrayField');
    }

    _this = _super5.call(this, {
      defaultVal: defaultVal,
      readOnly: readOnly
    });
    Object.assign(_assertThisInitialized(_this), {
      type: type
    });
    return _this;
  }

  _createClass(ArrayField, [{
    key: "clean",
    value: function clean(value) {
      var _this2 = this;

      return (0, _validation.notNullOrUndefined)(value) && (0, _validation.isArray)(value) ? value.map(function (i) {
        return _this2.type.clean(i);
      }) : this.getDefaultVal();
    }
  }]);

  return ArrayField;
}(Field);
/**
 * Instantiate a nested model or list of nested models
 */


exports.ArrayField = ArrayField;

var ModelField = /*#__PURE__*/function (_Field6) {
  _inherits(ModelField, _Field6);

  var _super6 = _createSuper(ModelField);

  function ModelField() {
    var _this3;

    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$defaultVal = _ref3.defaultVal,
        defaultVal = _ref3$defaultVal === void 0 ? null : _ref3$defaultVal,
        _ref3$readOnly = _ref3.readOnly,
        readOnly = _ref3$readOnly === void 0 ? false : _ref3$readOnly,
        _ref3$ModelClass = _ref3.ModelClass,
        ModelClass = _ref3$ModelClass === void 0 ? null : _ref3$ModelClass,
        _ref3$many = _ref3.many,
        many = _ref3$many === void 0 ? false : _ref3$many;

    _classCallCheck(this, ModelField);

    if (!ModelClass) {
      throw Error('ModelClass is a required parameter for ModelField');
    }

    _this3 = _super6.call(this, {
      defaultVal: defaultVal,
      readOnly: readOnly
    });
    Object.assign(_assertThisInitialized(_this3), {
      ModelClass: ModelClass,
      many: many
    });
    return _this3;
  }

  _createClass(ModelField, [{
    key: "clean",
    value: function clean(value) {
      var _this4 = this;

      if ((0, _validation.notNullOrUndefined)(value)) {
        // 2020-09-16 William: We're using `fromAPI` here in case we got JSON data
        //    that hasn't been camelCased. This is kind of a hack, but is
        //    _relatively_ harmless.
        return this.many ? value.map(function (i) {
          return _this4.ModelClass.fromAPI(i);
        }) : this.ModelClass.fromAPI(value);
      }

      return this.getDefaultVal();
    }
  }]);

  return ModelField;
}(Field);

exports.ModelField = ModelField;
var _default = {
  Field: Field,
  BooleanField: BooleanField,
  CharField: CharField,
  IdField: IdField,
  IntegerField: IntegerField,
  ArrayField: ArrayField,
  ModelField: ModelField
};
exports["default"] = _default;